import React from 'react'
import Carousel from '../../components/containers/Carousel'
import Contact from '../../components/containers/Contact'
import Hero from '../../components/containers/Hero'



export default function Landing() {
  return (
    <div>
        <Carousel /> 
        <Hero />
        <Contact />

    </div>
  )
}
